import React from 'react';
import PropTypes from 'prop-types';

function Footer(props) {
  return (
    <footer className="pb-4">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {props.children}
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Footer;
